// @flow
import type {UserAgentDeviceFlags} from '../../server/utils/systemData';

export const XS_MIN = 'XS_MIN';
export const SM_MIN = 'SM_MIN';
export const MD_MIN = 'MD_MIN';
export const LG_MIN = 'LG_MIN';
export const XL_MIN = 'XL_MIN';

/**
 * Responsive breakpoint constants
 * c.f. @homeaway/baseline/release/variables/_variables.less
 */
export const BREAKPOINTS = {
    XS_MIN: 480,
    SM_MIN: 768,
    MD_MIN: 992,
    LG_MIN: 1200,
    XL_MIN: 1480
};

export type Breakpoint = $Keys<typeof BREAKPOINTS>;

/**
 * Given an object of device flags, return an appropriate Breakpoint.
 * Used for server renders.
 * @param {UserAgentDeviceFlags} flags
 */
export const breakpointFromDeviceFlags = (
    flags: UserAgentDeviceFlags
): Breakpoint => {
    if (flags.isDesktop) {
        return 'MD_MIN';
    } else if (flags.isTablet) {
        return 'SM_MIN';
    }

    return 'XS_MIN';
};

/**
 * Test a breakpoint against a media query.
 * Only supports minWidth
 * @param {Breakpoint} current
 * @param {Breakpoint} minWidth
 */
export const media = (
    current: Breakpoint,
    {minWidth}: {minWidth: Breakpoint}
): boolean => {
    return BREAKPOINTS[current] >= BREAKPOINTS[minWidth];
};

export default BREAKPOINTS;
